import { render } from "./ResetGroupName.vue?vue&type=template&id=58279fa3&scoped=true"
import script from "./ResetGroupName.vue?vue&type=script&lang=js"
export * from "./ResetGroupName.vue?vue&type=script&lang=js"

import "./ResetGroupName.vue?vue&type=style&index=0&id=58279fa3&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58279fa3"]])

export default __exports__